import {createSelector} from 'reselect';
import {getCalendarData, getClasses} from '../../App/selectors';

export const selectCalendarData = createSelector([getCalendarData], calendarData => (calendarData ? calendarData.toJS() : []));
// selecting all weeks of calendar
export const selectCalendarWeeks = createSelector([getClasses], weeks => Object.keys(weeks.toJS()));
